import styled from 'styled-components';

import { mediaConfined, mediaWideNavless } from '@xing-com/layout-tokens';
import {
  SkeletonBodyCopy,
  SkeletonButton,
  SkeletonCard,
  SkeletonHeadline,
  SkeletonImage,
} from '@xing-com/skeleton';
import {
  scale100,
  scale180,
  scale260,
  scale410,
  spaceL,
  spaceM,
  spaceS,
  spaceXL,
  spaceXXL,
} from '@xing-com/tokens';

const RompSkeletonContainer = styled.div`
  margin-bottom: ${spaceXL};

  @media ${mediaWideNavless} {
    margin-bottom: ${spaceXXL};
  }
`;

const RompSkeletonBannerBasicBannerContainer = styled(SkeletonCard)`
  padding: ${spaceXL};
`;

const RompSkeletonBannerBasicBannerUserFlag = styled(SkeletonImage)`
  height: ${scale100};
  margin-bottom: ${spaceL};
  width: ${scale180};
`;

const RompSkeletonBannerBasicBannerHeadline = styled(SkeletonHeadline)`
  margin-bottom: ${spaceL};
  max-width: ${scale410};
`;

const RompSkeletonBannerBasicBannerBody = styled(SkeletonBodyCopy)`
  margin-bottom: ${spaceL};
`;

const RompSkeletonBannerBasicCTAButton = styled(SkeletonButton)`
  max-width: ${scale260};
`;

const RompSkeletonNonBasicHeadline = styled(SkeletonHeadline)`
  margin-block-end: ${spaceXL};

  @media ${mediaConfined} {
    max-width: 60%;
  }
`;

const RompSkeletonNonBasicSubline = styled(SkeletonHeadline)`
  margin-block-end: ${spaceL};

  @media ${mediaConfined} {
    max-width: 40%;
  }
`;

const RompSkeletonNonBasicItemWrapper = styled.div`
  &:not(:last-child) {
    margin-bottom: ${spaceXL};
  }
`;

const RompSkeletonNonBasicItemContainer = styled.div`
  display: flex;
  gap: ${spaceM};
  margin-bottom: ${spaceXL};
`;

const RompSkeletonNonBasicItemContentContainer = styled.div`
  flex: 1;
`;

const RompSkeletonNonBasicItemHeadline = styled(SkeletonHeadline)`
  margin-block-end: ${spaceS};

  @media ${mediaConfined} {
    max-width: 40%;
  }
`;

const RompSkeletonNonBasicItemBodyCopy = styled(SkeletonBodyCopy)`
  @media ${mediaConfined} {
    max-width: 50%;
  }
`;

const RompSkeletonNonBasicItemReasonBodyCopy = styled(SkeletonBodyCopy)`
  margin-block-end: ${spaceL};

  @media ${mediaConfined} {
    max-width: 60%;
  }
`;

export const Styled = {
  RompSkeletonContainer,
  RompSkeletonBannerBasicBannerContainer,
  RompSkeletonBannerBasicBannerUserFlag,
  RompSkeletonBannerBasicBannerHeadline,
  RompSkeletonBannerBasicBannerBody,
  RompSkeletonBannerBasicCTAButton,
  RompSkeletonNonBasicHeadline,
  RompSkeletonNonBasicSubline,
  RompSkeletonNonBasicItemWrapper,
  RompSkeletonNonBasicItemContainer,
  RompSkeletonNonBasicItemContentContainer,
  RompSkeletonNonBasicItemHeadline,
  RompSkeletonNonBasicItemBodyCopy,
  RompSkeletonNonBasicItemReasonBodyCopy,
};
